import * as React from "react";
import { BaseBlock, BaseBlockOptions, broadcastBlockLoad } from "sb-resp-lib";

import { BaseDict } from "./dict";
import { config } from "./config";
import { MyPulseBets } from "./MyPulseBets";
import { MyPulseBetsData } from "./data";
/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
import * as MOCKSTYPE from "sb-resp-lib/lib/mocks";
import * as localMOCKSTYPES from "../../mocks";
let _: typeof MOCKSTYPE;
let PageMethodsMock;
let MasterEventsPageMethodsMock;
let BettingHistoryPageMethodsMock;
let BasePlayByPlayMock;
let UserInfoMock;
let BettingPageMethodsMock;
let OddsMock;
let _localMocks: typeof localMOCKSTYPES;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-resp-lib/lib/mocks");
    _localMocks = require("../../mocks");
    PageMethodsMock = _.PageMethodsMock;
    MasterEventsPageMethodsMock = _localMocks.MasterEventsPageMethodsMock;
    BettingHistoryPageMethodsMock = _localMocks.BettingHistoryPageMethodsMock;
    BasePlayByPlayMock = _localMocks.BasePlayByPlayMock;
    UserInfoMock = _.UserInfoMock;
    OddsMock = _.OddsMock;
    BettingPageMethodsMock = _localMocks.BettingPageMethodsMock;
}

export class MyPulseBetsRoot extends BaseBlock {
    dataProvider!: MyPulseBetsData;
    options!: BaseBlockOptions;

    // constructor sets defaults
    constructor(
        domId: string,
        options: BaseBlockOptions = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
            betSlipUtil: {},
            oddsUtil: {},
            facade: {}
        }
    ) {
        super(domId, options);

        if (process.env.NODE_ENV === "development") {

            // setup data mocks for debug build
            this.dataProvider = new MyPulseBetsData({
                pageMethods: new PageMethodsMock(),
                masterEventsPageMethoods: new MasterEventsPageMethodsMock(),
                bettingHistoryPageMethods: new BettingHistoryPageMethodsMock(),
                basePlayByPlay: new BasePlayByPlayMock(),
                bettingPageMethods: new BettingPageMethodsMock(),
                userInfo: UserInfoMock
            },
                new OddsMock(),
                BaseDict,
                config
            );

            // setup dictionary for debug build
            this.options.dict = BaseDict;

            //export data store to window for debug purposes
            window["MyPulseBetsDATA"] = this.dataProvider;
        }

        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = { ...BaseDict, ...(options.dict || {}) };
        this.options.cms = { ...config, ...(options.cms || {}) };

        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {

            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new MyPulseBetsData(options.dataProvider, options.oddsUtil, this.options.dict, this.options.cms);
        }

        // merge default and CMS options
    }

    activate() {
        return super.activate(
            <MyPulseBets dataProvider={this.dataProvider} dict={this.options.dict} />
        );
    }
}

window["MyPulseBets"] = MyPulseBetsRoot;
broadcastBlockLoad("MyPulseBets");